'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';  \n  color: ', ';\n  padding: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n\n  @media(min-width: ', ') {\n    padding: ', ';\n  }\n'], ['\n  background-color: ', ';  \n  color: ', ';\n  padding: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  position: relative;\n\n  @media(min-width: ', ') {\n    padding: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable */

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$hasBackground ? _config.colors.lightGray : 'transparent';
}, function (props) {
  return props.$isValid ? props.color ? props.color : _config.colors.black : _config.colors.darkGray;
}, function (props) {
  return props.$hasBackground ? '20px 15px 30px 15px' : '0';
}, _config.breakpoints.m, function (props) {
  return props.$hasBackground ? '20px' : '0';
});

Wrapper.displayName = 'Wrapper';

exports.default = Wrapper;